import React from 'react';
import { HomeIcon, PlusIcon, UserIcon, FileIcon, LeafIcon, MinusCircleIcon, MessageSquareIcon, BellIcon, PenToolIcon } from 'lucide-react';
export function VendorSidebar({
  currentView,
  setCurrentView
}) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: HomeIcon
  }, {
    id: 'invoices',
    label: 'Invoices',
    icon: PlusIcon
  }, {
    id: 'upload-credit-note',
    label: 'Credit Notes',
    icon: MinusCircleIcon
  }, {
    id: 'documents',
    label: 'Documents',
    icon: FileIcon
  }, {
    id: 'communications',
    label: 'Communications',
    icon: MessageSquareIcon
  }, {
    id: 'reminders',
    label: 'Reminders',
    icon: BellIcon
  }, {
    id: 'esignature',
    label: 'eSignatures',
    icon: PenToolIcon
  }, {
    id: 'esg-profile',
    label: 'ESG Profile',
    icon: LeafIcon
  }, {
    id: 'profile',
    label: 'Profile',
    icon: UserIcon
  }];
  return <div className="w-64 bg-white shadow-md" data-id="element-1603">
      <nav className="mt-5 px-2" data-id="element-1604">
        <div className="space-y-1" data-id="element-1605">
          {navItems.map(item => {
          const Icon = item.icon;
          return <a key={item.id} href="#" onClick={e => {
            e.preventDefault();
            setCurrentView(item.id);
          }} className={`${currentView === item.id ? 'bg-indigo-50 text-indigo-600' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'} group flex items-center px-2 py-2 text-sm font-medium rounded-md`} data-id="element-1606">
                <Icon className={`${currentView === item.id ? 'text-indigo-600' : 'text-gray-400 group-hover:text-gray-500'} mr-3 h-5 w-5`} data-id="element-1607" />
                {item.label}
              </a>;
        })}
        </div>
      </nav>
    </div>;
}